import {
  Button,
  Card,
  CardContent,
  Container,
  debounce,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  InputAdornment,
  makeStyles,
  TextField,
  Tooltip,
  Typography,
  Chip,
} from '@material-ui/core';
import {
  AccountTree,
  Apps,
  Close,
  Create,
  List,
  PlayCircleFilled,
  Refresh,
  Search,
  Update,
} from '@material-ui/icons';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIncidents } from '../redux/incidents';
import Flag from './Flag';

const useStyles = makeStyles({
  dialogPaper: {
    minHeight: '70vh',
    minWidth: '30vw',
  },
});

const TaskPicker = ({ onSelect, onClose, defaultView, preFilter, ...props }) => {
  const classes = useStyles();
  const tasks = useSelector((state) => state.tasks);
  const [ageSortedTasks, setAgeSortedTasks] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [view, setView] = useState(defaultView || 'tree');
  const [filter, setFilter] = useState(preFilter);

  let textInput = null;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getIncidents());
  }, []);

  useEffect(() => {
    //do an age sort on the tasks for the flat view
    if (tasks?.length) {
      var t2 = [...tasks];
      t2.sort((a, b) => {
        if (a.age < b.age) return -1;
        else if (a.age > b.age) return 1;
        else return 0;
      });
      setAgeSortedTasks(t2);
    } else {
      setAgeSortedTasks([]);
    }

    //reapply the filter
    filterTasks(filter);
  }, [tasks]);

  useEffect(() => {
    filterTasks(filter);
  }, [view]);

  useEffect(() => {
    filterTasks(filter);
  }, [filter]);

  const onFilterChange = (e) => {
    updateFilter(e?.target?.value);
  };

  const updateFilter = useCallback(
    debounce((str) => {
      setFilter(str);
    }, 300),
    []
  );

  const filterTasks = (newFilter) => {
    const taskList = view == 'tree' ? tasks : ageSortedTasks;
    if (!newFilter) {
      setFilteredTasks(taskList?.length ? taskList : []);
    } else {
      const terms = newFilter.split(' ');
      const f = taskList.filter((task) => {
        const n =
          task.incidentId +
          ' ' +
          task.taskName.toLowerCase() +
          ' ' +
          task.incidentName.toLowerCase() +
          ' ' +
          task.companyName.toLowerCase() +
          ' ' +
          task.companyShortName.toLowerCase() +
          ' ' +
          (task.domain || '').toLowerCase() +
          ' taskid:' +
          task.taskId;
          if (terms.length == 1) {
            return n.indexOf(newFilter.toLowerCase()) != -1;
          } else {
            for (var i = 0; i < terms.length; i++) {
              if (n.indexOf(terms[i].toLowerCase()) == -1) return false;
            }
            return true;
          }
      });
      setFilteredTasks(f || []);
    }
  };

  if (!filteredTasks) return '';

  const showCompany = (task) => {
    return (
      <div style={{ cursor: 'default', marginTop: 8, borderBottom: 'black solid' }}>
        {task.companyName}
      </div>
    );
  };

  const showIncident = (task) => {
    return (
      <div
        style={{
          cursor: 'default',
          width: '100%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {task.incidentId}&nbsp;-&nbsp;
        {task.incidentName}
      </div>
    );
  };

  const showTask = (task) => {
    return (
      <div
        onClick={() => selectTask(task)}
        style={{ fontWeight: 800, marginLeft: 12, cursor: 'pointer' }}
      >
        {task.taskNumber}&nbsp;-&nbsp;{task.taskName}
      </div>
    );
  };

  const selectTask = (task) => {
    onSelect(task);
  };

  const showFlatTasks = (tasks) => {
    return (
      <Grid container spacing={1} style={{ cursor: 'pointer' }}>
        {tasks.map((task, index) => {
          const item = task;
          return (
            <Grid key={index} item xs={12} onClick={() => selectTask(task)}>
              <Card
                style={{
                  height: task.age != 9999 ? 100 : 80,
                  padding: 4,
                  backgroundColor: 'ededed',
                }}
              >
                <Grid container>
                  <Grid
                    item
                    xs={9}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                    }}
                  >
                    <div style={{ display: 'flex' }}>
                      <Flag item={item} style={{ marginTop: 4 }} />
                      <Typography color="textSecondary">{item.companyName}</Typography>
                    </div>
                    <Typography color="textSecondary">{item.incidentName}</Typography>
                    <Typography>{item.taskName}</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    style={{ display: 'flex', justifyContent: 'flex-end' }}
                  >
                    {item.incidentId && (
                      <Chip
                        style={{ marginBottom: -7 }}
                        label={item.incidentId}
                        variant="outlined"
                      />
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    {task.age != 9999 && (
                      <Typography>Used {task.age} days ago</Typography>
                    )}
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  const showTasks = (tasks) => {
    var c = '';
    var i = '';
    return tasks.map((task) => {
      if (task.companyName != c) {
        c = task.companyName;
        i = task.incidentName;
        return (
          <div key={task.taskId}>
            {showCompany(task)}
            {showIncident(task)}
            {showTask(task)}
          </div>
        );
      } else if (task.incidentName != i) {
        i = task.incidentName;
        return (
          <div key={task.taskId}>
            {showIncident(task)}
            {showTask(task)}
          </div>
        );
      } else {
        return <div key={task.taskId}>{showTask(task)}</div>;
      }
    });
  };

  return (
    <Dialog
      open={true}
      onClose={() => onClose()}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle>
        <Grid container>
          <Grid item xs={6}>
            Select task&nbsp;
            <Refresh
              onClick={() => {
                dispatch(getIncidents());
                setView('tree');
                //sortTasks('tree');
              }}
              style={{ fontSize: 20 }}
            />
          </Grid>
          <Grid item xs={6} style={{ textAlign: 'right' }}>
            {view == 'tree' ? (
              <Button
                onClick={() => {
                  setView('flat');
                }}
              >
                <Apps />
              </Button>
            ) : (
              <Button
                onClick={() => {
                  setView('tree');
                }}
              >
                <AccountTree />
              </Button>
            )}
          </Grid>
          <Grid item xs={9}>
            <TextField
              type="search"
              autoFocus
              label="Filter"
              inputRef={(input) => {
                textInput = input;
                if (filter && input) input.value = filter;
              }}
              onBlur={() => {
                textInput.focus();
              }}
              style={{ width: '100%' }}
              onChange={onFilterChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search style={{ cursor: 'pointer' }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid
            style={{ paddingRight: 23, paddingTop: 23, textAlign: 'right' }}
            item
            xs={3}
          >
            <Typography>{filteredTasks?.length} tasks</Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            {view == 'tree' ? showTasks(filteredTasks) : showFlatTasks(filteredTasks)}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default TaskPicker;
